import {
  DataElementForTable,
  OrderType,
  SortRows,
  SortRowsForKey,
} from '../../domain/schemas';

import { parseNumber } from '../parseNumber';

/**
 * typeがNumberの場合のソート処理
 * @param rows ソート対象のrows
 * @param index ソート対象の列のindex
 * @param order ソート条件
 */
export const sortNumber = <
  T extends
    | SortRows
    | SortRowsForKey
    | { data: DataElementForTable[]; date: string; day: string }
>(
  rows: T[],
  index: number,
  order: OrderType,
  /**
   * 呼び出し元の判定に使用する
   */
  tableName?: 'unitDataListTransition'
): T[] => {
  const compareNumbers = (a: T, b: T, order: OrderType) => {
    const valueA = a.data.at(index)?.value;
    const valueB = b.data.at(index)?.value;

    if (valueA == null || valueB == null) {
      return 0;
    }

    // queryParameterにnameが含まれる場合はvalueがnullの場合は一番上に配置(平均合計行の場合はnullなので一番上に持ってくる)
    if ('queryParameter' in a) {
      // aがSortRows型であることを確認
      if ('name' in a.queryParameter) {
        if (a.queryParameter.value === null) {
          return -1;
        }
      } else {
        // queryParameter.kiList(他の場合も)がnullの場合は一番上に配置(平均合計行の場合はnullなので一番上に持ってくる)
        if (
          a.queryParameter.kiList === null ||
          a.queryParameter.kiList?.at(0) === null ||
          a.queryParameter.sisTypes === null ||
          a.queryParameter.sisTypes?.at(0) === null ||
          a.queryParameter.makers === null ||
          a.queryParameter.makers?.at(0) === null ||
          a.queryParameter.halls === null ||
          a.queryParameter.halls?.at(0) === null
        ) {
          return -1;
        }
      }
    }
    if ('queryParameter' in b) {
      // bがSortRows型であることを確認
      if ('name' in b.queryParameter) {
        if (b.queryParameter.value === null) {
          return 1;
        }
      } else {
        if (
          b.queryParameter.kiList === null ||
          b.queryParameter.kiList?.at(0) === null ||
          b.queryParameter.sisTypes === null ||
          b.queryParameter.sisTypes?.at(0) === null ||
          b.queryParameter.makers === null ||
          b.queryParameter.makers?.at(0) === null ||
          b.queryParameter.halls === null ||
          b.queryParameter.halls?.at(0) === null
        ) {
          return 1;
        }
      }
    }

    if (tableName === 'unitDataListTransition' && 'date' in a && 'date' in b) {
      // 平均/合計行を最上部に持ってくる処理
      if (a.date === '平均/合計' || a.day === '-') {
        return -1; // 最上部に移動
      }
      if (b.date === '平均/合計' || b.day === '-') {
        return 1; // 最上部に移動
      }
    }

    // ハイフンを後ろにするための条件
    if (valueA === '-') return 1;
    if (valueB === '-') return -1;

    // カンマとパーセント記号が含まれる場合は削除して数値に変換
    const numA = parseNumber(valueA);
    const numB = parseNumber(valueB);

    if (isNaN(numA) || isNaN(numB)) {
      return 0;
    }

    return order === 'asc' ? numA - numB : numB - numA;
  };

  return rows.slice().sort((a, b) => compareNumbers(a, b, order));
};
